import { ERROR_BASKET_ID, getBasketId } from './getBasket';

export const ADD_CAREPLAN_PATH = 'checkout/baskets/[BASKET_ID]/products/[PRODUCT_ID]/carePlan';
export const ERROR_ADD_CAREPLAN_TO_BASKET =
  'There was an error adding the careplan to the basket.';
export const ERROR_ADD_CAREPLAN_TO_BASKET_INVALID_RESPONSE =
  'Invalid response received, when adding careplan to the basket.';

export const isResponseObjectValid = (response) => !!(
  response &&
  response.payload &&
  response.payload.id &&
  response.payload.products &&
  response.payload.products.length
);

export const isValidAddToBasketResponse = (basketId, productId, carePlanId, response) => {
  let isValid = false;
  if (isResponseObjectValid(response) && response.payload.id === basketId) {
    const basketProducts = response.payload.products;
    isValid = basketProducts
      .filter((product) => product &&
        product.id &&
        product.id === productId &&
        product.carePlan &&
        product.carePlan.id &&
        product.carePlan.id === parseInt(carePlanId, 10))
      .length > 0;
  }
  return isValid;
};

export const addCareplanToBasket = async (storeUrl, productId, carePlanId) => {
  const basketId = await getBasketId(storeUrl);
  if (!basketId) {
    throw new Error(ERROR_BASKET_ID);
  }
  const addCareplanPath = ADD_CAREPLAN_PATH
    .replace('[BASKET_ID]', basketId)
    .replace('[PRODUCT_ID]', productId);
  const addToBasketUrl = `${storeUrl}/${addCareplanPath}`;
  const params = { carePlanId };
  let addToBasketResponse;
  try {
    addToBasketResponse = await fetch(addToBasketUrl, {
      method: 'PUT',
      credentials: 'include',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json'
      }
    });
  } catch (e) {
    throw new Error(ERROR_ADD_CAREPLAN_TO_BASKET);
  }
  const addToBasketResponseJSON = await addToBasketResponse.json();
  if (isValidAddToBasketResponse(basketId, productId, carePlanId, addToBasketResponseJSON)) {
    return { basketId };
  }
  throw new Error(ERROR_ADD_CAREPLAN_TO_BASKET_INVALID_RESPONSE);
};
